import { DrawerObject } from '@/components/drawer/drawer.types';
import { PaymentJustificationDetailComponent } from '../payment-justification-detail/payment-justification-detail.component';

interface DetailDrawerProps {
  onApprove: () => void;
  onReject: () => void;
  onCancel: () => void;
}

export const getPaymentJustificationDetailDrawerObject = ({ onApprove, onReject, onCancel }: DetailDrawerProps): DrawerObject => {
  return {
    title: 'settings.paymentJustification.detail.title',
    description: 'settings.paymentJustification.detail.description',
    component: {
      outlet: PaymentJustificationDetailComponent,
      props: {},
    },
    width: '60vw',
    actions: [
      {
        label: 'settings.paymentJustification.detail.approve',
        onClick: onApprove,
        variant: 'success',
      },
      {
        label: 'settings.paymentJustification.detail.reject',
        onClick: onReject,
        variant: 'danger',
      },
      {
        label: 'settings.paymentJustification.detail.cancel',
        onClick: onCancel,
        variant: 'secondary',
      },
    ],
  };
};
